import { isNumber } from 'lodash';

export function buildAmount(amount?: number) {
  if (!isNumber(amount)) {
    return ['n/a', ''];
  }

  if (amount < 1) {
    return [Number((amount * 1e3).toFixed(6)), 'mg'];
  }

  if (amount >= 1e3) {
    return [Number((amount * 1e-3).toFixed(6)), 'kg'];
  }

  return [Number(amount.toFixed(6)), 'g'];
}
